import { gql } from '@apollo/client';
import styles from './Image.module.scss';
import classNames from 'classnames/bind';
import NextImage from 'next/image';

let cx = classNames.bind(styles);

export function Image({ image, sizes, width = undefined, height = undefined, fill = undefined, objectFit = undefined, objectPosition = undefined, id, className, src, alt, priority = false, style, loading }) {
	const imageAttrs = { ...image?.node };
	if (!fill) {
		height = height || imageAttrs.mediaDetails?.height;
		width = width || imageAttrs.mediaDetails?.width;
	}
	const classNameArray = className?.split(' ') || [];
	const imageStyles = {};
	if (objectFit) imageStyles.objectFit = objectFit;
	if (objectPosition) imageStyles.objectPosition = objectPosition;
  
	return (imageAttrs.sourceUrl || src) && (fill || (width && height)) ? (
		<div id={id} className={cx(['ns_image-container', 'image-container', ...classNameArray])} style={style}>
			<NextImage className={cx(['ns_image', 'image'])} height={height} width={width} sizes={sizes} alt={alt || imageAttrs.altText || ''} src={src || imageAttrs.sourceUrl} fill={fill} style={Object.keys(imageStyles).length !== 0 && imageStyles} quality={90} priority={priority} loading={loading} />
		</div>
	) : null;
}

Image.fragments = {
	entry: gql`
		fragment ImageFragment on AcfMediaItemConnectionEdge {
			node {
				altText
				id
				sourceUrl
				mediaDetails {
					height
					width
				}
			}
		}
	`,
};
